import React, { useEffect } from "react";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";
import { Checkbox, NativeSelect } from "@mui/material";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

export default function HyperParams(props) {
  const [params, setParams] = React.useState({});
  useEffect(() => {
    setParams(props.hyperParams);
  });

  return (
    <div>
      {Object.keys(params).map(
        (hpCategory) =>
          Object.keys(params[hpCategory]).length > 0 && (
            <div key={hpCategory}>
              <Typography variant="h6" gutterBottom>
                {hpCategory}
              </Typography>
              <Box
                component="form"
                sx={{
                  "& .MuiTextField-root": { m: 1 },
                  "& .MuiNativeSelect-root": { m: 1 },
                  "& .MuiNativeSelect-select": { marginTop: 1 },
                  "& . MuiCheckbox-root": { m: 1 },
                }}
              >
                {Object.keys(params[hpCategory]).map((paramKey) => (
                  <div key={paramKey}>
                    <TextField
                      disabled
                      label="Name"
                      type="text"
                      value={paramKey}
                      onChange={(e) =>
                        props.handleChange(hpCategory, paramKey, e.target.value)
                      }
                    />
                    <TextField
                      disabled={!params[hpCategory][paramKey].optimize}
                      label="Min"
                      type="text"
                      sx={{ width: "12ch" }}
                      value={params[hpCategory][paramKey].min}
                      onChange={(e) =>
                        props.handleChange(hpCategory, paramKey, {
                          ...params[hpCategory][paramKey],
                          min: e.target.value,
                        })
                      }
                    />
                    <TextField
                      disabled={!params[hpCategory][paramKey].optimize}
                      label="Max"
                      type="text"
                      sx={{ width: "12ch" }}
                      value={params[hpCategory][paramKey].max}
                      onChange={(e) =>
                        props.handleChange(hpCategory, paramKey, {
                          ...params[hpCategory][paramKey],
                          max: e.target.value,
                        })
                      }
                    />
                    <TextField
                      label="Init"
                      type="text"
                      sx={{ width: "12ch" }}
                      value={params[hpCategory][paramKey].init}
                      onChange={(e) =>
                        props.handleChange(hpCategory, paramKey, {
                          ...params[hpCategory][paramKey],
                          init: e.target.value,
                        })
                      }
                    />
                    {props.isPartofHPO && (
                      /* only show optimizable checkbox, if it actually can be optimized in the HPO */
                      <>
                        <FormControl>
                          <InputLabel
                            variant="standard"
                            htmlFor="uncontrolled-native"
                          >
                            Type
                          </InputLabel>
                          <NativeSelect
                            disabled
                            defaultValue={params[hpCategory][paramKey].type}
                            onChange={(e) =>
                              props.handleChange(hpCategory, paramKey, {
                                ...params[hpCategory][paramKey],
                                type: e.target.value,
                              })
                            }
                          >
                            <option value="int">int</option>
                            <option value="float">float</option>
                          </NativeSelect>
                        </FormControl>
                        <FormControl>
                          <InputLabel
                            variant="standard"
                            htmlFor="uncontrolled-native"
                          >
                            Scale
                          </InputLabel>
                          <NativeSelect
                            disabled
                            label="Scale"
                            defaultValue={params[hpCategory][paramKey].scale}
                            onChange={(e) =>
                              props.handleChange(hpCategory, paramKey, {
                                ...params[hpCategory][paramKey],
                                scale: e.target.value,
                              })
                            }
                          >
                            <option value="lin">lin</option>
                            <option value="exp">exp</option>
                            <option value="ixp">1-exp</option>
                          </NativeSelect>
                        </FormControl>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={params[hpCategory][paramKey].optimize}
                              onChange={(e) =>
                                props.handleChange(hpCategory, paramKey, {
                                  ...params[hpCategory][paramKey],
                                  optimize: e.target.checked,
                                })
                              }
                            />
                          }
                          label="optimize"
                        />
                      </>
                    )}
                  </div>
                ))}
              </Box>
            </div>
          )
      )}
    </div>
  );
}
